export enum AddressTypes {
  SHIPPING = 'Shipping',
  BILLING = 'Billing'
}

export type Language = 'nl' | 'en' | 'de' | 'ru' | 'es'
type AddressType = 'Shipping' | 'Billing'

export type ClientType = 'Individual'

export type RemoteDiagnoseItem = 'Remote diagnose'

export type TypeOfJob = 'Diagnose'

export type Address = {
  city?: string
  country: string
  company_name?: string
  address_line1?: string
  address_line2?: string
  postal_code?: string
  address_type?: AddressType
  disabled?: boolean
}

export type RemoteDiagnoseEvent = {
  client_type: ClientType
  client_name: string
  client_email: string
  address_shipping: Address
  address_billing: Address
  vehicle_registration_number: string
  vin: string
  date: string
  time: string
  country_code: string
  phone_number: string
  additional_phone_number: string
  question: string | null
  amount: number
  payment_method_types: string[]
  language: Language[]
  brand: string
  model: string
  new_client: boolean
  has_dongle: boolean
  client_mileage_state: string
  item: RemoteDiagnoseItem
  type_of_job: TypeOfJob
  project_name?: string
  dongle_tested?: boolean
  client_dsg_model: string
  terms_and_conditions_accepted: boolean,
  payment_gateway: "ideal" | "revolut" | "stripe",
  returnUrl: string
}

export type UpdateRemoteDiagnoseEvent = {
  language: Language[]
  question: string | null
  date: string
  name: string
  time: string
  payment_id: string
}

export type RescheduleRemoteDiagnoseEvent = {
  date: string
  time: string
  payment_id: string
}

export type Params = {
  clientId: string
  accepted: string
  country: string
  countryCode: string
}

export enum InvalidDSGModels {
  DSG_UNSURE = "Unsure of the model, but I'm certain my car has a DSG transmission"
}
